document.addEventListener("DOMContentLoaded", function () {
  addCollectionEventListeners();
  addFiltersEventListeners();
  entryAnimations();
});

function addCollectionEventListeners() {
  $a(".collection-description_buttons").forEach((element) =>
    element.addEventListener("click", (e) =>
      toggleCollectionDescriptionVisibility(e)
    )
  );

  x("#SortBy")?.addEventListener("change", (e) => {
    e.preventDefault();
    changeSort(e.target.value);
  });

  showHideDescriptionCollection();
}

function showHideDescriptionCollection() {
  var descriptionExcerpt = document.getElementsByClassName('collection-description_excerpt')[0];
  if (descriptionExcerpt == undefined) {
    return;
  }
  var collectionDescriptionButtons = document.getElementsByClassName('collection-description_buttons')[0];
  if (collectionDescriptionButtons == undefined) {
    return;
  }
  var numberChars = descriptionExcerpt.innerHTML.split(' ').length;  
  if (numberChars < 25) {
    collectionDescriptionButtons.style.display = 'none';
  }
}

function toggleCollectionDescriptionVisibility(e) {  
  let trigger = e.target;
  let contentExcerpt = x(".collection-description_excerpt");
  let contentFull = x(".collection-description_content");
  let readMoreTrigger = x(".collection-description__read-more");
  let readLessTrigger = x(".collection-description__read-less");
  let caretIcon = x(".collection-description_buttons svg");

  if (trigger) {
    if (contentExcerpt.classList.contains("hidden")) {
      //mostro contenuto troncato
      contentFull.classList.add("hidden");
      readLessTrigger.classList.add("hidden");

      contentExcerpt.classList.remove("hidden");
      readMoreTrigger.classList.remove("hidden");
      caretIcon.style.transform = "unset";
    } else {
      //mostro contenuto full
      contentFull.classList.remove("hidden");
      readLessTrigger.classList.remove("hidden");

      contentExcerpt.classList.add("hidden");
      readMoreTrigger.classList.add("hidden");
      caretIcon.style.transform = "rotate(180deg)";
    }
  }
}

function entryAnimations() {
  let title = x(".collection-hero__title");
  if (title) gsap.to(title, { opacity: 1, duration: 1 });
}
